import ModalComponent from '../components/ModalComponent';

interface Props {
  open: boolean
  handleClose: () => void
  handleSave: () => void
}

const Index = (props: Props) => {
  const { open, handleClose, handleSave } = props;

  return (
    <ModalComponent
      title="ログアウト確認"
      confirmButtonText="ログアウト"
      onConfirm={handleSave}
      show={open}
      closeModal={handleClose}
      centered
      animation={false}
    >
      <p className="mb-0">ログアウトしてもよろしいですか？</p>
    </ModalComponent>
  );
};

export default Index;
